import { CollectionViewer, DataSource } from '@angular/cdk/collections';
import { BehaviorSubject, Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { CarouselData } from './carousel.model';
import { CarouselService } from './carousel.service';

export class CarouselDataSource implements DataSource<CarouselData> {

  private dataSubject = new BehaviorSubject<CarouselData[]>([]);
  private dataLengthSubject = new BehaviorSubject<number>(0);
  private loadingSubject = new BehaviorSubject<boolean>(false);

  public data = this.dataSubject.asObservable();
  public dataLength = this.dataLengthSubject.asObservable();
  public loading = this.loadingSubject.asObservable();

  constructor(private carouselService: CarouselService) {}

  connect(collectionViewer: CollectionViewer): Observable<CarouselData[]> {
    return this.dataSubject.asObservable();
  }

  disconnect(collectionViewer: CollectionViewer): void {
    this.dataSubject.complete();
    this.loadingSubject.complete();
  }

  loadCarouselItems(
    pageIndex: number,
    pageSize: number,
    sortBy: string = 'created',
    sortDirection: string = 'asc',
    filter: string = '',
  ) {

    this.loadingSubject.next(true);

    this.carouselService
      .findPaginated(
        pageIndex,
        pageSize,
        sortBy,
        sortDirection,
        filter
      )
      .pipe(
        finalize(() => this.loadingSubject.next(false))
      )
      .subscribe(data => {
        this.dataSubject.next(data._embedded.carousel);
        this.dataLengthSubject.next(data.total_items);
      });
  }
}
